import { render } from "./OrgView.vue?vue&type=template&id=bff3bf42&scoped=true"
import script from "./OrgView.vue?vue&type=script&lang=js"
export * from "./OrgView.vue?vue&type=script&lang=js"

import "./OrgView.vue?vue&type=style&index=0&id=bff3bf42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff3bf42"]])

export default __exports__